import React from "react";
import {Tooltip} from "../common/Tooltip";
import "../common/SquareButton.css";
import "./BoldButton.css";

type BoldButtonProps = {
    className: string;
    tooltip?: string;
    disabled?: boolean;
    active?: boolean;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

export const BoldButton = (props: BoldButtonProps) => {
    return (
        <Tooltip title={props.tooltip ?? ''}>
            <span className={`bold-button square-button ${props.className}`}
                  aria-disabled={props.disabled === true}
                  data-active={props.active === true}
                  onClick={props.onClick}>&nbsp;</span>
        </Tooltip>
    );
}
